import React from 'react'
import SchemesSlider from '../Schemes/SchemesSlider'
import EventsHome from './EventsHome';
import MustOrderHome from './MustOrderHome';
import InventoryHome from './InventoryHome';
import FarmerSuggetions from './FarmerSuggetions';
import HomeTopButtonGroup from '../Components/HomeTopButtonGroup';
import CreditBalanceBoosterBox from '../IndicatorBox/CreditBalanceBoosterBox';
import CreditBalanceParisBox from '../IndicatorBox/CreditBalanceParisBox';
import CostCentreWiseBalanceForDistributor from '../IndicatorBox/CostCentreWiseBalanceForDistributor';
import FarmerInAreaBox from '../IndicatorBox/FarmerInAreaBox';
import FarmerAddedLastWeekBox from '../IndicatorBox/FarmerAddedLastWeekBox';
import RecentRecommendations from '../Recommendation/RecentRecommendations';
import TotalBilledAmountFYBox from '../IndicatorBox/TotalBilledAmountFYBox'
import TotalReceiptAmounts from '../IndicatorBox/TotalReceiptAmounts'

const Home = () => {
  setTimeout(function () {
    const checkUserType = localStorage.getItem('userType');
    if (checkUserType == 'BPUser') {
      window.location.replace("/BPUDashboard/BPUDashContent");
    }
  }, 100);

  return (
    <>

      <SchemesSlider />
      <div className="row">
        <div className="col-md-12">
          <div className="card card-success">
            <div className="card-header">
              <h3 className="card-title"> My Balance</h3>
            </div>
            <div className="row card-body">
              {/* <HomeTopButtonGroup /> */}
              <CreditBalanceBoosterBox />
              <CreditBalanceParisBox />
              {/* {<FarmerInAreaBox />} */}
              {/* {<CostCentreWiseBalanceForDistributor />} */}
              {/* {<FarmerAddedLastWeekBox />} */}
            </div>
          </div>
          <div className="card card-primary">
            <div className="card-header">
              <h3 className="card-title">My Balance - Details [Category Wise]</h3>
            </div>
            <div className="row card-body">
              {<CostCentreWiseBalanceForDistributor />}
              {/* <FarmerAddedLastWeekBox /> */}
            </div>
          </div>
          <div className="card card-warning">
            <div className="card-header">
              <h3 className="card-title">My Purchase-Payments</h3>
            </div>
            <div className="row card-body" >
              <TotalBilledAmountFYBox />
              <TotalReceiptAmounts />
            </div>
          </div>
          <div className="card card-warning">
            <div className="card-header">
              <h3 className="card-title">Farmers</h3>
            </div>
            <div className="row card-body" >
              <FarmerInAreaBox />
              <FarmerAddedLastWeekBox />
            </div>
          </div>
        </div>
      </div>
      <div className='row'>
        {/* <InventoryHome /> */}
        <FarmerSuggetions />
        <RecentRecommendations />
        <MustOrderHome />
        <EventsHome />
      </div>
    </>
  )
}

export default Home